import React from 'react';
import { SxProps, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Fab from '@mui/material/Fab';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import Tooltip from '@mui/material/Tooltip';

import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';
import AVDialogButton from '../AVDialogButton/AVDialogButton';
import { useTranslation } from 'react-i18next';
import { PSYLARIS_LIGHT_GREY, PSYLARIS_DARK } from '../../../utils/Colors';

const useStyles = makeStyles<Theme>((theme) => ({
  fab: {
    margin: theme.spacing(1),
    backgroundColor: PSYLARIS_LIGHT_GREY,
    color: PSYLARIS_DARK,
  },
}));

interface CompositeAudioButtonProps {
  disabled?: boolean;
  /**
   * Optional extra styles forwarded to the audio device dialog's modal-wrapper.
   * Use it to shift the dialog away from the EMDR sidebar on the practitioner page.
   */
  dialogWrapperSx?: SxProps<Theme>;
}

export default function CompositeAudioButton(props: CompositeAudioButtonProps) {
  const classes = useStyles();
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const [t] = useTranslation();
  const tooltipText = isAudioEnabled ? t('Mute Audio') : t('Unmute Audio');
  return (
    <div>
      <Tooltip title={tooltipText} placement="top" PopperProps={{ disablePortal: true }}>
        <span>
          <Fab
            className={classes.fab}
            size={'large'}
            onClick={toggleAudioEnabled}
            disabled={props.disabled}
            data-cy-audio-toggle
            data-testid="pwid-audio-toggle"
          >
            {isAudioEnabled ? <MicIcon /> : <MicOffIcon />}
          </Fab>
        </span>
      </Tooltip>
      <AVDialogButton isAudio={true} t={t} dialogWrapperSx={props.dialogWrapperSx} />
    </div>
  );
}
